<template>
  <div class="md-layout">

    <div centered class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-large-size-80 md-xlarge-size-70 " style="margin:0 auto;">
      <div class="md-layout">
        <div class="md-layout-item md-size-20 md-small-size-100  text-right">
          <h1 class="section-header">{{$t('contact-us')}}</h1>
        </div>
        <div class="jp-holiday-notice md-layout-item md-size-80 md-small-size-100" v-show="showHolidayNotice" v-html="holidayContent"></div>
      </div>
    </div>

    <div centered class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-large-size-80 md-xlarge-size-70 page-container">
      <div class="md-layout">
        <div class="md-layout-item md-size-20 md-small-size-100 page-container-side text-right">
          <div style="width:80%;float:right"><h3>{{$t('mode-of-contact')}}</h3></div>
        </div>
        <div class="md-layout-item md-size-80 md-small-size-100">

          <div class="page-container-section">
            <div>{{$t('select-mode-of-contact')}}</div>
            <div>
              <md-radio v-model="radio" :value="false" v-on:change="closeChat()">{{$t('email-us')}}</md-radio>
            </div>
            <div v-if="showChat">
              <md-radio v-model="radio" :value="true" v-on:change="clickChat()">Online Chat <div>: online</div></md-radio>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>




<script>
  import { mapState } from 'vuex'

  export default {
    name: 'ModeOfContact',
    data: () => ({
      showChat: false,
      radio: false,
      showHolidayNotice: false,
      holidayContent: ''
    }),
    computed: {
      ...mapState({
        store: 'store'
      })
    },
    methods: {
      closeChat() {
        if (typeof (window.zE) == 'function') {
          window.zE('messenger', 'close')
        }
        return
      },
      clickChat() {
        if (typeof (window.zE) == 'function') {
          window.zE('messenger', 'open')
        }
        return
      },
      fetchHolidayNotice() {
        fetch('/camp/holiday_notice_api/?q=rma')
          .then(res => res.json())
          .then(data => {
            if (data?.content && data?.startDate && data?.endDate) {
              const today = new Date();
              const start = new Date(data.startDate);
              const end = new Date(data.endDate);
              if (today >= start && today <= end) {
                this.holidayContent = data.content;
                this.showHolidayNotice = true;
              }
            }
          })
          .catch(() => {
            this.showHolidayNotice = false;
          });
      }
    },
    created() {
      switch (this.store.toUpperCase()) {
        case "SG":
        case "AU":
        case "US":
        case "CA":
        case "UK":
          this.showChat = true;
          break;
        default:
          this.showChat = false;
          break;
      }
      
      if (this.store === 'jp') {
        this.fetchHolidayNotice();
      }
    }
  }
</script>

<style lang="scss" scoped>
  small {
    display: block;
  }
  .md-radio:not(.md-disabled), .md-radio:not(.md-disabled) .md-radio-label {
    margin: 5px 0;
  }
  .md-radio-label > div {
    float: right;
    margin-left: 5px;
    text-transform: capitalize;
  }
</style>
